/** Simpson Disk Renderer — long axis, base and disc mesh on the overlay canvas. */

import type { SimpsonResult, SimpsonRenderOptions } from './types';

/**
 * Renders Simpson to a Canvas 2D context.
 */
export function renderSimpsonToCanvas(
  ctx: CanvasRenderingContext2D,
  result: SimpsonResult,
  options: SimpsonRenderOptions
): void {
  const {
    diskColor,
    axisColor,
    baseColor,
    diskOpacity = 0.8,
    lineWidth = 1.5,
  } = options;

  ctx.save();

  // 1. Draw the contour (if available)
  // This is normally already done by FreehandROI

  // 2. Long axis (dashed line)
  ctx.strokeStyle = axisColor;
  ctx.lineWidth = lineWidth;
  ctx.setLineDash([4, 2]);
  ctx.beginPath();
  ctx.moveTo(result.apex.x, result.apex.y);
  ctx.lineTo(result.baseMidpoint.x, result.baseMidpoint.y);
  ctx.stroke();
  ctx.setLineDash([]);

  // 3. Base line
  ctx.strokeStyle = baseColor;
  ctx.lineWidth = lineWidth;
  ctx.beginPath();
  ctx.moveTo(result.baseLeft.x, result.baseLeft.y);
  ctx.lineTo(result.baseRight.x, result.baseRight.y);
  ctx.stroke();

  // 4. Markers
  ctx.fillStyle = axisColor;
  ctx.beginPath();
  ctx.arc(result.apex.x, result.apex.y, 3, 0, Math.PI * 2);
  ctx.fill();

  ctx.fillStyle = baseColor;
  ctx.beginPath();
  ctx.arc(result.baseMidpoint.x, result.baseMidpoint.y, 3, 0, Math.PI * 2);
  ctx.fill();

  // 5. Disk lines — a step below the structural lines, thin at any state.
  ctx.strokeStyle = diskColor;
  ctx.lineWidth = 1;
  ctx.globalAlpha = diskOpacity;

  result.disks.forEach((disk) => {
    ctx.beginPath();
    ctx.moveTo(disk.leftPoint.x, disk.leftPoint.y);
    ctx.lineTo(disk.rightPoint.x, disk.rightPoint.y);
    ctx.stroke();
  });

  ctx.globalAlpha = 1;

  // Labels are handled by Cornerstone's draggable text box
  // (customFreehandROIGetTextLines in useSharedToolState.ts).

  ctx.restore();
}
